import ErrorBoundary from "@/components/ErrorBoundary/errorBoundary.component";
import SidebarModelButton from "@/infrastructure/Sidebar/SidebarModels/sidebarModelButton.component";
import { AppContext } from "@/services/AppContext/appContext";
import { Button } from "@/shadcn/components/ui/button";
import { ScrollArea } from "@/shadcn/components/ui/scroll-area";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shadcn/components/ui/tooltip";
import { RefreshCw } from "lucide-react";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

type SidebarModelsProps = {
  hideSidebar: () => void;
};

const SidebarModels: React.FC<SidebarModelsProps> = ({ hideSidebar }) => {
  const { agentsModels, refreshAllAgentModels } = useContext(AppContext);
  const { t } = useTranslation();
  return (
    <div className="grid w-full gap-1">
      <div>
        <div className="flex w-full items-center justify-between px-2 py-1 text-sm font-bold">
          <span>{t("Agents")}</span>
          <TooltipProvider>
            <Tooltip delayDuration={200}>
              <TooltipTrigger asChild>
                <Button
                  variant="ghost"
                  className="h-6 w-6 p-0"
                  onClick={async () => {
                    await refreshAllAgentModels();
                  }}
                >
                  <RefreshCw className="h-4 w-4" />
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>{t("Refresh")}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      </div>
      <ScrollArea className="max-h-40 w-full flex-1 grow overflow-hidden">
        <div className="grid gap-1 p-1">
          {agentsModels.length === 0 ? (
            <div className="flex w-full items-center justify-center text-sm">
              {t("No agents available")}
            </div>
          ) : (
            agentsModels.map((model) => (
              <ErrorBoundary key={model.id} fallback={<div>Error</div>}>
                <SidebarModelButton
                  key={model.id}
                  model={model}
                  hideSidebar={hideSidebar}
                />
              </ErrorBoundary>
            ))
          )}
        </div>
      </ScrollArea>
    </div>
  );
};

export default SidebarModels;
